export default function () {
  return {
    notificationSystemData: [],
    notificationUpdatesData: [],
    notificationSystemLoading: false,
    notificationUpdatesLoading: false,
    notificationSystemCount: 0,
    notificationUpdatesCount: 0,
    notificationSystemNew: 0,
    notificationUpdatesNew: 0,
    notificationsCountsLoading: false,
  };
}
